(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["il-rider-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('il-rider-gallery')) {
  customElements.define('il-rider-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.rl-rider-track');
      if (!this.track) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.count = this.querySelector('[data-gallery-count]');
      this.toggle = this.querySelector('[data-gallery-toggle]');
      this.slides = Array.from(this.track.children);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.inView = false;
      this.querySelector('.rl-rider-controls').hidden = false;
      this.previous.addEventListener('click', () => { this.pause(); this.move(-1); }, {signal});
      this.next.addEventListener('click', () => { this.pause(); this.move(1); }, {signal});
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateAutoplay();
      }, {signal});
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.updateAutoplay();
      }, {signal});
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.updateAutoplay();
      }, {signal});
      this.addEventListener('focusin', event => {
        if (event.target !== this.toggle) this.pause();
      }, {signal});
      this.track.addEventListener('pointerdown', () => this.pause(), {passive:true, signal});
      this.track.addEventListener('wheel', () => this.pause(), {passive:true, signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.pause();
      }, {signal});
      document.addEventListener('visibilitychange', () => this.updateAutoplay(), {signal});
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.sync(), 100);
      }, {passive:true, signal});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          this.pause();
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          this.pause();
          event.preventDefault();
          this.scrollTo(event.key === 'Home' ? 0 : this.track.scrollWidth);
        }
      }, {signal});
      this.resize = new ResizeObserver(() => { this.sync(); this.updateAutoplay(); });
      this.resize.observe(this.track);
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
        this.updateAutoplay();
      }, {threshold:[0,.3]});
      this.visibility.observe(this.track);
      this.sync();
      this.updateAutoplay();
    }
    pause() {
      this.paused = true;
      this.updateAutoplay();
    }
    canRotate() {
      return !this.paused && !this.hovered && this.inView && !document.hidden && this.track.scrollWidth > this.track.clientWidth + 1;
    }
    updateAutoplay() {
      const label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.setAttribute('title', label);
      this.toggle.classList.toggle('is-paused', this.paused);
      this.count.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      this.dataset.autoplay = this.paused ? 'paused' : this.canRotate() ? 'playing' : 'waiting';
      this.schedule();
    }
    schedule() {
      clearTimeout(this.rotationTimer);
      if (!this.canRotate()) return;
      this.rotationTimer = setTimeout(() => {
        if (!this.canRotate()) return;
        const atEnd = this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft <= 1;
        if (atEnd) this.scrollTo(0);
        else this.move(1);
        this.schedule();
      }, 4000);
    }
    step() {
      return this.slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
    }
    scrollTo(left) {
      this.track.scrollTo({left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    move(direction) {
      const step = this.step();
      this.scrollTo((Math.round(this.track.scrollLeft / step) + direction) * step);
    }
    sync() {
      const step = this.step();
      if (!step) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const visible = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / step));
      const first = Math.min(this.slides.length, Math.round(this.track.scrollLeft / step) + 1);
      const last = Math.min(this.slides.length, first + visible - 1);
      const label = (first === last ? String(first) : first + '–' + last) + ' / ' + this.slides.length;
      if (this.count.textContent !== label) this.count.textContent = label;
      this.previous.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft <= 1;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.rotationTimer);
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["il-ui"] && !Shopify.designMode) return;
  try {
    (()=>{
  const init=()=>{
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile=matchMedia('(max-width: 800px)');
    const root=document.body;
    const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(n/100);
    if('IntersectionObserver' in window&&!reduced){
      document.documentElement.classList.add('il-motion-ready');
      const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('il-inview');reveal.unobserve(e.target)}}),{threshold:.08});
      document.querySelectorAll('[data-reveal]').forEach(el=>reveal.observe(el));
    }
    const track=document.querySelector('[data-hero-track]');
    const ambient=document.querySelector('[data-ambient-video]');
    const toggle=document.querySelector('[data-motion-toggle]');
    let userPaused=false,heroVisible=true;
    const playAmbient=async()=>{if(!ambient||userPaused||!heroVisible)return;const source=ambient.querySelector('source');if(source?.dataset.src){source.src=source.dataset.src;delete source.dataset.src;ambient.load()}try{await ambient.play();ambient.classList.add('is-playing');if(toggle){toggle.textContent=toggle.dataset.pause;toggle.setAttribute('aria-pressed','true')}}catch{ambient.classList.remove('is-playing');if(toggle){toggle.textContent=toggle.dataset.play;toggle.setAttribute('aria-pressed','false')}}};
    const pauseAmbient=()=>{ambient?.pause();if(toggle){toggle.textContent=toggle.dataset.play;toggle.setAttribute('aria-pressed','false')}};
    if(toggle)toggle.addEventListener('click',()=>{if(!ambient.paused){userPaused=true;pauseAmbient()}else{userPaused=false;playAmbient()}});
    if(ambient&&'IntersectionObserver' in window){new IntersectionObserver(es=>{heroVisible=es[0].isIntersecting;if(!heroVisible)pauseAmbient();else if(!reduced&&!navigator.connection?.saveData)playAmbient()},{threshold:.08}).observe(track||ambient)}
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAmbient();else if(!userPaused&&!reduced&&!navigator.connection?.saveData)playAmbient()});
    if(track&&!reduced){let pending=false,mx=0,my=0;const render=()=>{pending=false;if(mobile.matches||!heroVisible)return;const r=track.getBoundingClientRect();const p=Math.min(1,Math.max(0,-r.top/Math.max(1,r.height-innerHeight)));track.style.setProperty('--il-progress',p.toFixed(3));track.style.setProperty('--il-mx',mx.toFixed(2));track.style.setProperty('--il-my',my.toFixed(2))};const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(render)}};addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});if(matchMedia('(hover:hover) and (pointer:fine)').matches){track.addEventListener('pointermove',e=>{mx=e.clientX/innerWidth-.5;my=e.clientY/innerHeight-.5;schedule()},{passive:true});track.addEventListener('pointerleave',()=>{mx=0;my=0;schedule()})}schedule()}
    document.querySelectorAll('.il-mobile-nav a').forEach(a=>a.addEventListener('click',()=>a.closest('details').removeAttribute('open')));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.il-mobile-nav[open]').forEach(d=>d.removeAttribute('open'))});
    document.querySelectorAll('[data-product-section]').forEach(section=>{
      const img=section.querySelector('.il-main-product-image');
      const dialog=section.querySelector('.il-zoom-dialog');
      const setImage=(src,alt)=>{if(!img||!src)return;img.removeAttribute('srcset');img.src=src;if(alt)img.alt=alt;if(dialog){dialog.querySelector('img').src=src;dialog.querySelector('img').alt=img.alt}};
      section.querySelectorAll('[data-gallery-image]').forEach(btn=>btn.addEventListener('click',()=>{setImage(btn.dataset.galleryImage,btn.dataset.galleryAlt);section.querySelectorAll('[data-gallery-image]').forEach(b=>{b.classList.toggle('is-active',b===btn);b.setAttribute('aria-pressed',String(b===btn))})}));
      section.querySelector('[data-open-zoom]')?.addEventListener('click',()=>{if(dialog&&typeof dialog.showModal==='function')dialog.showModal()});
      section.querySelector('[data-close-zoom]')?.addEventListener('click',()=>dialog.close());
      dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
      const form=section.querySelector('[data-il-buy]');if(!form)return;
      let variants=[];try{variants=JSON.parse(section.querySelector('[data-product-variants]').textContent)}catch{return}
      const idInput=()=>form.querySelector('input[name="id"]:checked')||form.querySelector('select[name="id"]')||form.querySelector('input[name="id"]');
      const current=()=>variants.find(v=>String(v.id)===String(idInput()?.value));
      const button=form.querySelector('[data-add-button]');
      const error=form.querySelector('[data-form-error]');
      const updateTotal=()=>{const v=current();if(!v)return;let total=v.price;form.querySelectorAll('[data-addon]').forEach(row=>{const check=row.querySelector('[data-addon-check]');const sel=row.querySelector('[data-addon-select]');if(!sel||!check)return;const price=sel.tagName==='SELECT'?Number(sel.selectedOptions[0]?.dataset.price||0):Number(sel.dataset.price||0);if(check.checked)total+=price;if(sel.tagName==='SELECT'){sel.disabled=!check.checked;sel.required=check.checked}const label=row.querySelector('[data-addon-price]');if(price&&label&&!row.classList.contains('is-soldout'))label.textContent=money(price)});form.querySelector('[data-config-total]').textContent=money(total);section.querySelector('[data-product-price]').textContent=money(v.price);const compare=section.querySelector('[data-compare-price]');compare.hidden=!(v.compare_at_price>v.price);if(!compare.hidden)compare.textContent=money(v.compare_at_price);button.disabled=!v.available;button.querySelector('span').textContent=v.available?root.dataset.addLabel:root.dataset.soldoutLabel;document.querySelectorAll('[data-sticky-price]').forEach(el=>el.textContent=money(total))};
      form.querySelector('[data-addons]')?.removeAttribute('hidden');form.querySelector('[data-warranty-options]')?.removeAttribute('hidden');
      form.addEventListener('change',e=>{if(e.target.matches('[data-variant-choice]')){const v=current();const src=e.target.dataset.image||v?.featured_image?.src;if(src)setImage(src,v?.name);const url=new URL(location.href);url.searchParams.set('variant',idInput().value);history.replaceState({},'',url);section.querySelectorAll('[data-gallery-image]').forEach(b=>{const selected=b.dataset.galleryImage===src;b.classList.toggle('is-active',selected);b.setAttribute('aria-pressed',String(selected))})}updateTotal()});
      let submitting=false;
      form.addEventListener('submit',async e=>{e.preventDefault();if(submitting||!form.reportValidity())return;const v=current();if(!v?.available)return;error.hidden=true;const withWarranty=form.querySelector('[data-warranty-addon] [data-addon-check]')?.checked;const items=[{id:v.id,quantity:1,...(withWarranty?{properties:{_il_warranty:'extended'}}:{})}];for(const row of form.querySelectorAll('[data-addon]')){if(row.querySelector('[data-addon-check]')?.checked){const id=row.querySelector('[data-addon-select]')?.value;if(id)items.push({id:Number(id),quantity:1,...(row.hasAttribute('data-warranty-addon')?{parent_id:v.id}:{})})}}submitting=true;button.disabled=true;button.querySelector('span').textContent=root.dataset.addingLabel;try{const response=await fetch(root.dataset.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||root.dataset.errorLabel);location.assign(root.dataset.cartUrl)}catch(ex){error.textContent=ex.message||root.dataset.errorLabel;error.hidden=false;error.scrollIntoView({block:'nearest',behavior:reduced?'instant':'smooth'});submitting=false;updateTotal()}});
      updateTotal();
      const sticky=document.querySelector('.il-sticky-buy');if(sticky&&'IntersectionObserver'in window)new IntersectionObserver(es=>sticky.classList.toggle('is-visible',!es[0].isIntersecting&&es[0].boundingClientRect.top<0),{threshold:0}).observe(button);
    });

    document.querySelectorAll('[data-youtube]').forEach(btn=>btn.addEventListener('click',()=>{const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/'+btn.dataset.youtube+'?autoplay=1&rel=0';frame.title=btn.dataset.videoTitle;frame.allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';btn.replaceWith(frame)}));
    document.querySelectorAll('[data-detail-video]').forEach(video=>{const source=video.querySelector('source');const loadVideo=()=>{if(source.dataset.src){source.src=source.dataset.src;delete source.dataset.src;video.load()}};video.addEventListener('play',loadVideo,{once:true});if('IntersectionObserver'in window)new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){loadVideo();if(!reduced&&!mobile.matches&&!navigator.connection?.saveData)video.play().catch(()=>{})}else video.pause()}),{threshold:.3}).observe(video)});
    const cartForm=document.querySelector('#IlCartForm');if(cartForm){const syncWarranty=()=>{cartForm.querySelectorAll('[data-parent-key]').forEach(row=>{const parent=Array.from(cartForm.querySelectorAll('[data-line-key]')).find(p=>p.dataset.lineKey===row.dataset.parentKey);const parentInput=parent?.querySelector('input[name="updates[]"]');const childInput=row.querySelector('input[name="updates[]"][readonly]');if(parentInput&&childInput)childInput.value=parentInput.value})};cartForm.addEventListener('input',syncWarranty);cartForm.addEventListener('submit',syncWarranty)}

  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

})();
